import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { EYesNo } from '../../../../../shared/models/types.enum';

@Component({
  selector: 'impressions',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './impressions.component.html',
  styleUrl: './impressions.component.css'
})
export class ImpressionsComponent implements OnInit, OnChanges {

  @Input() witnessInterviewData: any = {};
  @Output() onSaveSection4 = new EventEmitter<any>();

  yesNo = EYesNo;
  impressionForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "What do you think he or she meant when saying/doing that? *",
      formControlName: "student_meaning",
    },
    {
      question: "How do you feel about what he or she said/did? *",
      formControlName: "student_feelings",
    },
    {
      question: "Why, in your opinion, did he or she say that? *",
      formControlName: "opinion",
    }
  ]

  radioQuestions = [
    {
      id: 'know_student',
      questionText: "Do you know this student? *",
      formControlName: 'know_student',
      infoFormControlName: 'know_student_information'
    },
    {
      id: 'harm_concern',
      questionText: "Are you concerned that he or she might actually follow through and harm someone? *",
      formControlName: 'harm_concern',
      infoFormControlName: 'harm_concern_information'
    },
    {
      id: 'history_influence',
      questionText: 'Are you aware of any history or situations that may have influenced this situation? *',
      formControlName: 'history_influence',
      infoFormControlName: 'history_influence_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['witnessInterviewData'] && this.witnessInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm() {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.witnessInterviewData && this.witnessInterviewData[question.formControlName] !== undefined
                           ? this.witnessInterviewData[question.formControlName]
                           : this.yesNo.No;  

      group[question.formControlName] = new FormControl(
          String(defaultValue), 
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.witnessInterviewData?.[question.infoFormControlName] || '', disabled: this.witnessInterviewData?.[question.infoFormControlName] ? false : true });
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.witnessInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.impressionForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  setupFormChangeHandlers() {
    this.radioQuestions.forEach(question => {
      const control = this.impressionForm.get(question.formControlName);
      if (control) {
        control.valueChanges.subscribe(value => {
          const infoControl = this.impressionForm.get(question.infoFormControlName);
          if (infoControl) {
            this.formUtils.handleConditionChange(infoControl, value === EYesNo.Yes);
          }
        });
      }
    });
  }

  saveImpression(): void {
    if (this.impressionForm.valid) {
      this.onSaveSection4.emit(this.impressionForm.value);
    }
  }

}
